<template>         
    <v-tab :href="tabuiid" @dblclick.native="editTabName" @click.stop.prevent="$store.myActions.UI_NAVTO_DETAIL({uiid,cmp:tab.cmp,isleft,id:tab.id})" :title="tabTooltip" >        
      <template v-if="edited">
        <drag :transfer-data="{cmp:tab.cmp,isleft,id:tab.id}" class="drag">
          <v-text-field style="margin-top:14px" autofocus @keyup.esc="cancelEdit"  @keyup.enter="closeAndSave" label="Tab Name" v-model="tmpName"></v-text-field>
          <v-spacer />
        </drag>
        <v-btn class="mr-0" small icon @click.prevent.stop="closeAndSave" :title="$t('Pilot.MissionInfos.SaveTooltip')">
          <v-icon small>mdi-content-save</v-icon>
        </v-btn>
      </template>
      <template v-else>
        <drag class="drag" :transfer-data="{cmp:tab.cmp,isleft,id:tab.id}">{{ tryTranslate(tab.label) }}
          <v-spacer />
        </drag>
        <v-btn class="mr-0" small icon @click.prevent.stop="close" :title="$t('Pilot.MissionInfos.CloseDetailTabTooltip')">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-tab>  
</template>
<script lang="ts">
  
  import { UiTab } from '@/models/ui/UiTab';  
  import Vue from 'vue'
  import Component from 'vue-class-component'

  @Component({
    name: 'SimulationDetailNavTab', 
    props: {            
      isleft:Boolean,
      tab:{
        type:Object,
        required:true
      },
      uiid:{
        type:String,
        required:true
      }
    }
  })
  export default class SimulationDetailNavTab extends Vue {    
  
    uiid!:string
    tab!:UiTab
    isleft!:boolean

    edited = false
    tmpName = ""
   
   mounted() {      
   }
   
    get tabuiid(){
      return `${this.tab.cmp}-${this.tab.id}`
    }
    get tabTooltip(){
      return this.edited?`${this.tab.label} - ${this.$t('Pilot.MissionInfos.EscToCancel')}`:
                    `${this.tab.label} - ${this.$t('Pilot.MissionInfos.DoubleClickToRename')}`
    }
     
    tryTranslate(key:string) {        
      const transKey = `Pilot.MissionDetailMenu.${key}`
      const trad = this.$t(transKey).toString()
      return transKey == trad?key:trad
    }

    close(){
      this.$store.myActions.UI_SET_MEASURETOOL('NONE')
      this.$store.myActions.UI_UNSELECT_TAB({uiid:this.uiid,cmp:this.tab.cmp,id:this.tab.id,isleft:this.isleft})        
    }

    editTabName() {
      this.tmpName = this.tryTranslate(this.tab.label)
      this.edited = true        
    }
    closeAndSave() {
      this.$store.myActions.UI_RENAME_DETAIL({uiid:this.uiid,cmp:this.tab.cmp,id:this.tab.id,isleft:this.isleft,label:this.tmpName})
      this.edited = false
    }
    cancelEdit() {                
      this.edited = false
    }
  }  

</script>

<style>
.drag{
  display: flex;  
  height: 100%;
  align-items: center;  
}
</style>